import React from "react";
import Layout from "../layout/Layout";
import YearChart from "./YearChart";
import SalesIniciative from "./SalesIniciative";
import YearChart2 from "./YearChart2";

const SalesDashboard = () => {
	return (
		<Layout
			title="Sales Dashboard"
			description=""
			// className='container'
		>
			<h4>Plan vs Real (yards)</h4>
			<YearChart />
			{/* <YearChart2 /> */}
			<h4>Seller Status</h4>
			<SalesIniciative scope="all" />
			<h4>Commercial Team</h4>
			<SalesIniciative scope="commercial" />
			<h4>Residential Team</h4>
			<SalesIniciative scope="residential" />
			<h4>Residential Team 1</h4>
			<SalesIniciative scope="residential1" />
			<h4>Residential Team 2</h4>
			<SalesIniciative scope="residential2" />
			<h4>Residential Team 3</h4>
			<SalesIniciative scope="residential3" />
			{/* <h4>Corporate Team</h4>
			<SalesIniciative scope="corporate" />
			<h4>Others</h4>
			<SalesIniciative scope="others" /> */}
		</Layout>
	);
};

export default SalesDashboard;
